const { location: { hostname, port }, } = window;
// const LOCAL = hostname === 'localhost';
const getStaticPath = () => {
    const nodeEnv = process.env.NODE_ENV;
    switch (nodeEnv) {
        case 'production':
            return `${process.env.STATIC_CONTENT_PREFIX_HTTPS}${hostname}`;
        case 'development':
            return `${process.env.STATIC_CONTENT_PREFIX}${hostname}:8000`;
        default:
            return `${process.env.STATIC_CONTENT_PREFIX}${hostname}:8000`;
    }
};
export default {
    hostname,
    port,
    static: getStaticPath(),
};
